const converters = {
  methods: {
    blobToBase64 (blob) {
      const reader = new FileReader()
      reader.readAsDataURL(blob)
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result)
        }
      })
    },
    blobToArrayBuffer (blob) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(blob)
      return new Promise((resolve) => {
        reader.onloadend = () => {
          resolve(reader.result)
        }
      })
    }
  }
}

export default converters
